var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevops1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 123,
    viewBox: "0 0 105 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3455_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 27.0121C0 17.3458 7.83604 9.50977 17.5023 9.50977H69.0817C78.7479 9.50977 86.584 17.3458 86.584 27.0121V78.5915C86.584 88.2577 78.7479 96.0938 69.0817 96.0938H17.5023C7.83605 96.0938 0 88.2577 0 78.5915V27.0121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5023 10.0567H69.0817C78.4459 10.0567 86.037 17.6479 86.037 27.0121V78.5915C86.037 87.9556 78.4459 95.5468 69.0817 95.5468H17.5023C8.13812 95.5468 0.546947 87.9556 0.546947 78.5915V27.0121C0.546947 17.6479 8.13811 10.0567 17.5023 10.0567Z",
    stroke: "#B1C1CF",
    strokeWidth: 1.09389
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7312 63.3423H29.4181C29.2451 63.3423 29.1035 63.4839 29.1035 63.6569V66.0163C29.1035 66.1894 29.2451 66.3309 29.4181 66.3309H57.7312C57.9043 66.3309 58.0458 66.1894 58.0458 66.0163V63.6569C58.0458 63.4839 57.9043 63.3423 57.7312 63.3423ZM38.6592 45.4775H41.5652V58.7808C41.5652 58.9538 41.7068 59.0954 41.8798 59.0954H44.2392C44.4123 59.0954 44.5538 58.9538 44.5538 58.7808V45.4775H47.4677C47.7312 45.4775 47.8767 45.1747 47.7155 44.9703L43.3112 39.3941C43.2818 39.3565 43.2442 39.3261 43.2012 39.3052C43.1583 39.2843 43.1112 39.2734 43.0635 39.2734C43.0157 39.2734 42.9686 39.2843 42.9257 39.3052C42.8827 39.3261 42.8451 39.3565 42.8157 39.3941L38.4115 44.9663C38.2502 45.1747 38.3957 45.4775 38.6592 45.4775Z",
    fill: "#243251"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3455_7593",
    x: -17.5023,
    y: 0.758619,
    width: 121.589,
    height: 121.589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.75115
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.75115
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.686275 0 0 0 0 0.776471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3455_7593"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3455_7593",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevops1);
export default __webpack_public_path__ + "static/media/Devops1.2659d2ba5fce55f3a49234c14e743007.svg";
export { ForwardRef as ReactComponent };